module.exports = __webpack_public_path__ + "html/subscription-payment-details-container_473db9463a75880eff23b90bb5a48c10.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/containers/subscription-payment-details-container.html
// module id = ItJd
// module chunks = 17